import { WebPlugin } from '@capacitor/core';
export class WidgetImageStoreWeb extends WebPlugin {
    async save(_options) {
        void _options;
        throw this.unimplemented('save is not implemented on web.');
    }
    async delete(_options) {
        void _options;
        throw this.unimplemented('delete is not implemented on web.');
    }
    async list(_options) {
        void _options;
        throw this.unimplemented('list is not implemented on web.');
    }
    async deleteExcept(_options) {
        void _options;
        throw this.unimplemented('deleteExcept is not implemented on web.');
    }
    async exists(_options) {
        void _options;
        throw this.unimplemented('exists is not implemented on web.');
    }
    async getPath(_options) {
        void _options;
        throw this.unimplemented('getPath is not implemented on web.');
    }
}
//# sourceMappingURL=web.js.map